import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const useDefaultChecklistValues = () => {
  const { type } = useParams();

  const { checklist } = useSelector((state) => state.trikes);
  const { checklists } = useSelector((state) => state.powerAfrica);

  if (type === "trike" && checklist.length) {
    return checklist;
  }

  if (type === "tiller" && checklists?.tiller?.length) {
    return checklists.tiller;
  }

  if (type === "miller" && checklists?.miller?.length) {
    return checklists.miller;
  }

  if (type === "water-pump" && checklists?.waterPump?.length) {
    return checklists.waterPump;
  }

  if (type === "thresher" && checklists?.thresher?.length) {
    return checklists?.thresher;
  }

  if (type === "chaff-cutter" && checklists?.chaffCutter?.length) {
    return checklists?.chaffCutter;
  }

  return [
    {
      partId: "",
      partName: "",
      mandatory: false,
    },
  ];
};

export const useExistingChecklist = () => {
  const { type } = useParams();

  const { checklist } = useSelector((state) => state.trikes);
  const { checklists } = useSelector((state) => state.powerAfrica);

  const checklistMap = {
    trike: checklist.length,
    tiller: checklists?.tiller?.length,
    miller: checklists?.miller?.length,
    "water-pump": checklists?.waterPump?.length,
    thresher: checklists?.thresher?.length,
    "chaff-cutter": checklists?.chaffCutter?.length,
  };

  return Boolean(checklistMap[type]);
};

export default useDefaultChecklistValues;
